<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/stock/conversions">{{ $t("stock_conversion") }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
            </button>
            <button
                    type="button"
                    class="btn btn-outline-primary btn-sm no-bor"
                    @click="onSave()">
                <i class="fa fa-floppy-o"></i> {{ $t("save") }}
            </button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <form ref="form">
                        <div v-if="$v.$error" class="alert alert-danger x-error">
                            <div class="error" v-if="!$v.model.UomId.required">- សូមធ្វើការបញ្ជូលឈ្មោះ</div>
                            <div class="error" v-if="!$v.model.Item.required">- សូមធ្វើការជ្រើសរើសវត្ថុ</div>
                            <div class="error" v-if="!$v.model.Price.required">- សូមធ្វើការបញ្ជូលតម្លៃ</div>
                            <div class="error" v-if="!$v.model.UnitQty.required">- សូមធ្វើការបញ្ជូលចំនួន</div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label class="label-control blue">{{$t('item_name')}}</label>
                                    <AuthCompleted @select="itemSelect" :value="model.ItemName" :disabled="isDisabled"></AuthCompleted>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.UomId.$error }">
                                    <label class="label-control blue">{{$t('uom')}}</label>
                                    <div>
                                        <select class="form-control form-control-sm" v-model="$v.model.UomId.$model" :disabled="model.ItemId=='' ||  isDisabled">
                                            <option value="">Not Set</option>
                                            <option v-for="ret in uomList" :value="ret.Id" :key="ret.Id">{{ret.Code}} | {{ret.Name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="label-control blue">{{ $t("barcode") }} </label>
                                    <div><input class="form-control form-control-sm" type="text" v-model="model.Barcode" :disabled="model.ItemId==''" /></div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-2">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.UnitQty.$error }">
                                    <label class="label-control blue">{{ $t("unit_qty") }}</label>
                                    <div>
                                        <input type="number" class="form-control form-control-sm" v-model="$v.model.UnitQty.$model" :disabled="model.ItemId==''" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.Price.$error }">
                                    <label class="label-control blue">{{ $t("price") }}</label>
                                    <div>
                                        <input type="number" class="form-control form-control-sm" v-model="$v.model.Price.$model" :disabled="model.ItemId==''" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="form-group" :class="{ 'form-group-error': $v.model.Cost.$error }">
                                    <label class="label-control blue">{{ $t("cost") }}</label>
                                    <div>
                                        <input type="number" class="form-control form-control-sm" v-model="$v.model.Cost.$model" :disabled="model.ItemId==''" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    import { AuthCompleted } from '../Item';
    export default {
        components: {
            AuthCompleted
        },
        data: function () {
            return {
                model: {
                    UomId: '',
                    UnitQty: 1,
                    Cost: 0,
                    Barcode: '',
                    Price: 0,
                    ItemId: '',
                    ItemName: ''
                },
                uomList: [],
                isDisabled: false,
                title: this.$t('item_price_create')
            }
        },
        validations: {
            model: {
                UomId: { required },
                UnitQty: { required },
                Price: { required },
                Cost: { required }
            }
        },
        created: function () {
            let id = this.$route.params.id;
            this.listUom();
            if (id !== undefined && id != null && id !== "") {
                this.$api()
                    .post("item/price/find", { Id: id })
                    .then((res) => {
                        if (this.$isValid(res)) {
                            this.model = res.data.Data;
                        }
                    });
                this.isDisabled = true,
                this.title = this.$t('item_price_edit')
            }
        },
        methods: {
            onSave(){
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    this.$api().post('item/price/save', this.model).then(res => {
                        if(this.$isValid(res)){
                            this.$router.push('/stock/conversions');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            listUom() {
                this.$api().post('uom', { ItemId: this.model.ItemId }).then(res => {
                    if (this.$isValid(res)) {
                        this.uomList = res.data.Data;
                    }
                })
            },
            itemSelect(e){
                this.model.ItemId = e.Id;
                this.model.ItemName = e.Name;
                this.model.UomId = '';
                this.listUom();
            }
        },
    }
</script>